import React from 'react';
import { ContentShare } from '../content-share';
import { RichText } from '../rich-text';

export class ContentColumns extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <section className="content-columns">
        <div className="content-columns__container container">
          <div className="content-columns__left typo-body">
            <RichText document={this.props.contentLeft} language={this.props.language} />
          </div>
          <div className="content-columns__spacer" />
          <div className="content-columns__right typo-body">
            <RichText document={this.props.contentRight} language={this.props.language} />

            { !this.props.hideSocialShareButtons && <ContentShare /> }  
          </div>
        </div>
      </section>
    );
  }
}